const SDK_VERSION = "10.78.0" ;

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
